<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="员工：">
					<el-select v-model="formInline.userKeyId" placeholder="请先选择门店" clearable filterable size="small" :disabled="!formInline.storeKeyId" @change="inputChange">
						<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期：">
					<el-date-picker
						v-model="dateStr"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						size="small"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeCost/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
	</div>
</template>

<script>
import { GetAttendanceInfoPageList } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "考勤记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			dateStr: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				userKeyId: "",
				startTime: null,
				endTime: null
			},
			storeList: [],
			userList: [], // 员工列表
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center"
				},
				{
					prop: "userName",
					label: "打卡员工",
					minWidth: "100",
					align: "center"
				},
				{
					prop: "cardTime",
					label: "打卡时间",
					minWidth: "180",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 根据门店获取人员列表
		getUserListByStore(storeKeyId) {
			const paramer = {
				keyId: storeKeyId
			};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取人员信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetAttendanceInfoPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 门店选择器change事件
		handleStoreChange(val) {
			// 清空已选员工
			this.formInline.userKeyId = "";
			// 根据门店获取员工列表
			if (val) {
				this.getUserListByStore(val);
			} else {
				this.userList = [];
			}
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 日期选择器事件
		handleDateChange(val) {
			if (val.length > 0) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		}
	}
};
</script>

<style scoped></style>
